import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import request from "../../utils/request.js";
import t from "../../utils/translation.js";

import SearchMaterial from "../../components/SearchMaterial/SearchMaterial.js";
import CrudIndicator from "../../components/CrudIndicator/CrudIndicator.jsx";

import BarcodeReader from "react-barcode-reader";

import { parseBarcode } from "../../utils/BarcodeParser.js";
import DragAndDropCharges from "../../components/DragAndDropCharges/DragAndDropCharges.js";
import LocalizationContext from "../../utils/LocalizationContext.js";
import { v4 as uuidv4 } from "uuid";
import InputQ from "../../components/FormComponents/InputQ/InputQ.jsx";
import { getSession, getUserCompany } from "../../utils/sessionHandler.js";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SelectQ from "../../components/FormComponents/SelectQ/SelectQ.jsx";
import PageContainer from "../../components/PageContainer/PageContainer.jsx";

import styles from "./CreateHygieneMonitoring.module.css";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import TextAreaQ from "../../components/FormComponents/TextAreaQ/TextAreaQ.jsx";
import ModalLoading from "../../components/ModalLoading/ModalLoading.js";
import SelectorMaterialHygiene from "../../components/SelectorMaterialHygiene/SelectorMaterialHygiene.js";
import { Checkbox } from "@material-ui/core";
import Redirect from "../../utils/Redirect";
import VinculationPro from "../../components/VinculationPro/VinculationPro.jsx";
import Search from "../../components/Search/Search.js";
import InputSearch from "../../components/FormComponents/InputSearch/InputSearch.jsx";

const MySwal = withReactContent(Swal);

export default function CreateHygieneMonitoring({ location }) {
  const [indicators, setIndicators] = useState([]);
  const [usedProgram, setUsedProgram] = useState("");
  const [cycleNumber, setCycleNumber] = useState("");
  const [observations, setObservations] = useState(null);
  const [packages, setPackages] = useState([]);
  const [editPackages, setEditPackages] = useState([]);
  const [filteredPackages, setFilteredPackages] = useState("");
  const [selectedPackages, setSelectedPackages] = useState([]);
  const [selectedFilteredPackages, setSelectedFilteredPackages] = useState([]);
  const [searchActive, setSearchActive] = useState(false);
  const [editId, setEditId] = useState(null);
  const [sterilizers, setSterilizers] = useState([]);
  const [selectedSterilizer, setSelectedSterilizer] = useState("");
  const [validate, setValidate] = useState(false);
  const [scanCode, setScanCode] = useState("");
  const [methodName, setMethodName] = useState("");
  const [modelAreas, setModelAreas] = useState([]);
  const [methodId, setMethodId] = useState(null);
  const [stopButtons, setStopButtons] = useState(false);
  const [idDistributorCompany, setIdDistributorCompany] = useState(null);
  const [modalEditLoading, setModalEditLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [packageQuantity, setpackageQuantity] = useState(1000000);
  const [clearSearch, setClearSearch] = useState(null);
  const [Washers, setWashers] = useState(null);
  const [selectedWasher, setSelectedWasher] = useState();
  const [vinculation, setVinculation] = useState();
  const [filters, setFilters] = useState();
  const [error, setError] = useState(null);
  const [relatedChargeWashingId, setRelatedChargeWashingId] = useState("");
  const [isEndoscope, setIsEndoscope] = useState();
  const [chargeId, setChargeId] = useState(null);
  const [selectedIndicator, setSelectedIndicator] = useState([]);
  const [reload, setReload] = useState(false);
  const locale = useContext(LocalizationContext);
  const [materialDeselected, setMaterialDeselected] = useState(false);
  const [description, setDescription] = useState("");
  const [IQAS,setIQAS] = useState(false)
  const [cyclesOptions, setcyclesOptions] = useState([])

  const usedProgramRef = useRef();
  const cycleRef = useRef();
  const observationsRef = useRef();
console.log(cycleNumber)
  const validateFields = (status) => {
    let notValid = false;
    if (status === 1) {
      if (!selectedWasher || selectedWasher === "") {
        notValid = true;
      }
      if (!cycleNumber || cycleNumber === "") {
        notValid = true;
      }
      if (!selectedPackages || selectedPackages.length === 0) {
        notValid = true;
      }
    } else {
      if (!selectedWasher || selectedWasher === "") {
        notValid = true;
      }

      if (!cycleNumber || cycleNumber === "") {
        notValid = true;
      }

      if (!selectedPackages || selectedPackages.length === 0) {
        notValid = true;
      }

      if (!indicators || indicators.length === 0) {
        notValid = true;
      }
    }

    return notValid;
  };

  const handleMaterialDeselected = (isDeselected) => {
    setMaterialDeselected(isDeselected);
    if (isDeselected && indicators.length > 0) {
      MySwal.fire({
        title: "Are you sure you want to continue?",
        text: "All entered materials and indicators will be lost.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        customClass: {
          confirmButton: "confirmButton",
          cancelButton: "cancelButton",
        },
        confirmButtonColor: "var(--primary-green)",
        cancelButtonColor: "var(--delete)",
        backgroundColor: "#f4f4f4",
      }).then((result) => {
        if (result.isConfirmed) {
          setIndicators([]);
          setPackages([]);
          setFilteredPackages("");
          setSelectedPackages([]);
          fetchMaterialsEdit(cycleNumber);
        }
      });
    }
  };

  // const fetchMaterials = async (cycleNumber) => {
  //   setModalLoading(true);
  //   setError(null);
  //   try {
  //     const response = await request().get(
  //       `/api/Material/byWashingCycle?CycleNumber=${cycleNumber}&washerId=${selectedWasher}`
  //     );
  //     setPackages(response.data);
  //     const relatedChargeWashingId =
  //       response.data.length > 0
  //         ? response.data[0].relatedChargeWashingId
  //         : null;
  //     setRelatedChargeWashingId(relatedChargeWashingId);
  //   } catch (error) {
  //     console.error("Error fetching materials:", error);
  //     setError("Error al obtener los materiales.");
  //   } finally {
  //     setModalLoading(false);
  //     setCycleNumber(cycleNumber.replace(scanCode, ""));
  //   }
  // };

  const fetchCycles = async (cycleNumber) => {
    setModalLoading(true);
    setError(null);
    try {
      // Primera llamada para obtener las opciones de ciclos
      const cyclesResponse = await request().get(
        `/api/chargeWashing/ByWashingCycle?CycleNumber=${cycleNumber}&WasherId=${selectedWasher}`
      );
      setcyclesOptions(
        cyclesResponse.data.map(cycle => ({
            cycleNumber: String(cycle.cicle)
        }))
    );
    } catch (error) {
      console.error("Error fetching cycles:", error);
      setError("Error al obtener los ciclos de lavado.");
    } finally {
      setModalLoading(false);
    }
};

const fetchMaterials = async (selectedCycle) => {
    setModalLoading(true);
    setError(null);
    try {
      // Segunda llamada después de seleccionar una opción
      const response = await request().get(
        `/api/Material/byWashingCycle?CycleNumber=${selectedCycle}&washerId=${selectedWasher}`
      );
      setPackages(response.data);
      const relatedChargeWashingId =
        response.data.length > 0
          ? response.data[0].relatedChargeWashingId
          : null;
      setRelatedChargeWashingId(relatedChargeWashingId);
    } catch (error) {
      console.error("Error fetching materials:", error);
      setError("Error al obtener los materiales.");
    } finally {
      setModalLoading(false);
    }
};

  const fetchMaterialsEdit = async (cycleNumber) => {
    setModalLoading(true);
    setError(null);
    try {
      const response = await request().get(
        `/api/Material/byWashingCycle?CycleNumber=${cycleNumber}&washerId=${selectedWasher}`
      );
      setPackages(response.data)
    } catch (error) {
      console.error("Error fetching materials:", error);
      setError("Error al obtener los materiales.");
    } finally {
      setModalLoading(false);
    }
  };

  const addScanIndicator = (indicator) => {
  
    if (indicators.find((i) => i.id === indicator.id)) {
      indicators.find((i) => i.id === indicator.id).quantity++;
      toast.success(t("IndicatorAdded", locale) || "Indicator Added");
    } else {
      indicator = { ...indicator, quantity: 1 };
      setIndicators([...indicators, indicator]);
      toast.success(t("IndicatorAdded", locale) || "Indicator Added");
    }
  };

  const onHandleScan = async (data) => {
    let itemMaterial = packages.find((m) => m.serial == data);

    let materialCondition = selectedPackages.find((m) => m.serial == data);

    if (itemMaterial) {
      setScanCode(data);
      if (materialCondition) {
        setSelectedPackages(selectedPackages.filter((m) => m != itemMaterial));
        toast.success(t("MaterialRemoved", locale) || "Material removed");
      } else {
        setSelectedPackages([itemMaterial]);
        toast.success(t("MaterialAdded", locale) || "Material added");
      }
    } else {
      try {
        const variableField = parseBarcode(data).parsedCodeItems[3];
        const Gtin = parseBarcode(data).parsedCodeItems[0];
        let lot = "";
        const handleResponse = async (url) => {
          const response = await request().get(url);

          if (response.data.id && (response.data.indicator?.name === "PRO1ENDO" || "PRO1MICRO")) {
            if (indicators.length === 1) {
              toast.error(t("BlankEntry41"));
              return;
            }
            setScanCode(data);
            if (!isEndoscope) {
                    if (response.data.indicator.name.toUpperCase() === "PRO1MICRO") {
                    } else if (response.data.indicator.name.toUpperCase() === "PRO1ENDO") {
                      toast.error(
                        t("BlankEntry43") ||
                          "You must select a endoscope/cannulated."
                      );
                      return;
                    }
                  }
            if (
                    isEndoscope === undefined || isEndoscope === null
                  ) {
                    toast.error(t("BlankEntry48") || "Select material.");
                    return;
                  }
            let newIndicator = response.data;
            addScanIndicator(newIndicator);

            setCycleNumber(cycleNumber.replace(data, ""));
          }
        };

        if (variableField.ai === "10") {
          const url = `/api/indicatorLot/GTINforHygiene?gtin=${Gtin.data}&lot=${
            variableField.data
          }&disId=${getUserCompany().DistributorId}`;
          await handleResponse(url);
        } else if (variableField.data.includes("PANTONE")) {
          let match = variableField.data.match(/(.{6})95PANTONE/);
          if (match) {
            lot = match[1];
          }
          const url = `/api/indicatorLot/GTINforHygiene?gtin=${
            Gtin.data
          }&lot=${lot}&disId=${getUserCompany().DistributorId}`;
          await handleResponse(url);
        } else {
          const answer = variableField.data;

          let product;

          const indexA = answer.lastIndexOf("A");
          const indexF = answer.lastIndexOf("F");
          const indexB = answer.lastIndexOf("B");
          const indexBT = answer.lastIndexOf("BT");
          const indexPCD = answer.lastIndexOf("PCD");
          const indexCDWA = answer.lastIndexOf("CDWA");

          if (indexA < indexB) {
            if (indexB !== -1) {
              lot = answer.substring(indexB);
              const startAfterB = indexB - 2;

              if (indexCDWA !== -1) {
                product = answer.substring(indexCDWA, startAfterB);
                console.log(product);
              }
            }
          } else if (indexA > indexF) {
            if (indexA !== -1) {
              lot = answer.substring(indexA);

              const startAfterA = indexA - 2;

              if (indexBT !== -1) {
                product = answer.substring(indexBT, startAfterA);
              }
            }
          } else if (indexA < indexF) {
            if (indexF !== -1) {
              lot = answer.substring(indexF);
              const startAfterF = indexF - 2;

              if (indexPCD !== -1) {
                product = answer.substring(indexPCD, startAfterF);
              }
            }
          }

          const url = `/api/IndicatorLot/lotForHygiene?Product=${product}&lot=${lot}&distId=${getUserCompany().DistributorId}`
          await handleResponse(url);
        }
      } catch (e) {
        toast.error(e.response?.data?.message);
      } finally {
        setModalLoading(false);

        handleCycleNumber(cycleNumber.toString().replace(data, ""), true);
      }
    }
  };

  const getParametersCreate = async () => {
    try {
      const response = await request().get(`/api/parameter/chargeWashing`);

      const washers = response.data.washers.map((item) => ({
        value: item.washerId,
        ...item,
      }));

      setWashers(washers);
    } catch (error) {
      console.error("Error al obtener esterilizadores:", error);
    }
  };

  const hygieneEditId = location?.state?.hygieneEditId;

  const getEditCharges = () => {
    try {
      setModalEditLoading(true);

      request()
        .get(`/api/hygiene/${hygieneEditId}`)
        .then((response) => {
          // if (response.data.id) localStorage.removeItem("hygieneEditId");
          setSelectedWasher(response.data.washerId);
          setCycleNumber(response.data.relatedCicleNumber);
          fetchMaterialsEdit(response.data.relatedCicleNumber);
          setRelatedChargeWashingId(response.data.chargeWashingId);
          setSelectedPackages(
            response.data.materials.map((m) => ({
              ...m,
              name: m.material.name,
              serial: m.material.serial,
              id: m.materialId,
              isEndoscope: m.material.isEndoscope 
            }))
          );
          setEditId(response.data.id);
          setIsEndoscope(response.data.materials.map((m) => ({
            isEndoscope: m.material.isEndoscope
          })))
          setObservations(response.data.description);
          setIndicators(
            response.data.indicators.map((i) => ({
              ...i,
              indicator: { name: i.indicator.name },
              indicator_Id: i.indicatorId,
              uuid: uuidv4(),
              expirationDate: response.data.indicatorExpirationDate
            }))
          );
          location.state.hygieneEditId = null;
        });
    } catch (e) {
      location.state.hygieneEditId = null;
      setEditId(null);
    } finally {
      setModalEditLoading(false);
    }
  };

  const handleIndicators = (data) => {
    if (indicators.length > 1) return;

    setIndicators(data);
  };

  const handleChangeIQAS = (m) => setIQAS(m.target.checked);

  const handleSelectedIndicator = (data) => {
    setSelectedIndicator(data);
  };
  const handleChangeObservations = (e, scan = false) => {
    let item = scan ? e : e.target.value;
    setObservations(item);
  };

  const timeoutRef = useRef(null);

  const handleClick = (option) => {
    setCycleNumber(option.cycleNumber);
    fetchMaterials(option.cycleNumber)
  };




const handleCycleNumber = (value, scan = false) => {

  const inputValue = scan ? value : String(value).trim();

  if (!scan && inputValue.length === 0) {
      setValidate(false);
      setFilteredPackages("");
      setSelectedPackages([]);
      setPackages([]);
      setIndicators([]);
  }

  if (scan) {
      if (/^[1-9][0-9]*$/.test(inputValue)) {
          setCycleNumber(inputValue);
          fetchCycles(inputValue);
          setSelectedPackages(selectedPackages);
      }
  } else {
      if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
      } 
      timeoutRef.current = setTimeout(() => {
          if (/^[1-9][0-9]*$/.test(inputValue)) {
              setCycleNumber(inputValue);
              fetchCycles(inputValue);
              setSelectedPackages(selectedPackages);
          } else {
              setCycleNumber(""); 
              setFilteredPackages("");
              setSelectedPackages([]);
              setPackages([]);
              setIndicators([]);
          }
      }, 300);

      setCycleNumber(inputValue);
      fetchCycles(inputValue);
      setSelectedPackages(selectedPackages);
  }
};

  const handleFilteredPackages = (data) => {
    setFilteredPackages(data);
  };

  const handleSelectedPackages = (data) => {
    setSelectedPackages(data);
    if (data && data[0]) {
      setIsEndoscope(data[0].isEndoscope);
    } else {
      setIsEndoscope(null);
    }
  };

  const handleChangeWasher = (e) => {
    const selectedValue = e.target.value;
    setSelectedWasher(selectedValue);
    setCycleNumber("");
    setFilteredPackages("");
    setPackages([]);
    setSelectedPackages([]);
    setIndicators([]);
  };

  const handleClearSearch = (data) => {
    setClearSearch(data);
  };

  const getIdDistributorCompany = () => {
    const infouser = getSession();

    if (infouser.SectorId)
      request()
        .get(`/api/Sector/${infouser.SectorId}`)
        .then((res) => {
          infouser.SectorName = res.data.name;
          setIdDistributorCompany(
            infouser.IdDistributorCompany.replace(/-/g, "")
          );
        });
    else return;
  };

  const createCharge = async (status) => {
    const newMaterials = selectedPackages.map((material) => ({
      materialId: material.id,
      quantity: material.quantity || 1,
    }));

    const newIndicators = indicators.map((indicator) => ({
      indicatorId: indicator.indicator_Id,
      quantity: indicator.quantity || 1,
      lot: indicator.lot || null,
    }));

    const requestData = {
      Description: observations,
      Materials: newMaterials,
      Indicators: newIndicators,
      WasherId: selectedWasher,
      ChargeWashingId: relatedChargeWashingId,
      status: status === 1 ? 1 : 4,
      ignoreFromIQAS: IQAS,
    };

    try {
      setModalLoading(true);
      setStopButtons(true);

      if (!editId) {
        await request()
          .post("/api/hygiene", requestData)
          .then((res) => {
            const chargeId = res.data;
            setChargeId(chargeId);

            if (status !== 1) {
              request()
                .get(`/api/hygiene/${chargeId}`)
                .then((detailsRes) => {
                  setSelectedIndicator(detailsRes.data.indicators);
                  setVinculation(true);
                });
            } else {
              setEditId(res.data)
            }

            status === 1
              ? toast.success(t("BlankEntry44") || "Testing saved successfully")
              : toast.success(t("BlankEntry45")|| "Testing completed successfully");
          });
      } else {
        requestData.id = editId;
        await request()
          .put("/api/hygiene", requestData)
          .then((res) => {
            toast.success(t("BlankEntry46") || "Testing modified successfully");
            const chargeId = res.data;
            setChargeId(chargeId);
            if (status !== 1) {
              request()
                .get(`/api/hygiene/${chargeId}`)
                .then((detailsRes) => {
                  setSelectedIndicator(detailsRes.data.indicators);
                  setVinculation(true);
                });
            } else {
              setEditId(res.data)
            }
          });
      }

      if (status !== 1) {
        clearFields(true);
      }
    } catch (e) {
      toast.error(e.response?.data?.message || "An error occurred");
    } finally {
      setModalLoading(false);
      setStopButtons(false);
    }
  };

  const clearFields = (sterilizerChange = true) => {
    sterilizerChange && setUsedProgram("");
    sterilizerChange && setEditId(null);
    sterilizerChange && setSelectedSterilizer("");
    sterilizerChange && setMethodName("");
    sterilizerChange && setMethodId(null);
    setCycleNumber("");
    setObservations("");
    setIndicators([]);
    setFilteredPackages("");
    setSelectedPackages([]);
    setPackages([]);
    setSelectedWasher("");
  };

  useEffect(() => {
    getEditCharges();
    getIdDistributorCompany();
    getParametersCreate();
  }, [selectedWasher]);

  useEffect(() => {
    setCycleNumber(cycleNumber.toString().replace(scanCode, ""), true);
    setScanCode("");
  }, [scanCode]);

  useEffect(() => {
    if (scanCode) {
      let itemMaterial = packages.find((m) => m.serial == scanCode);
      let materialCondition = selectedPackages.find((m) => m.serial == scanCode);
  
      if (itemMaterial) {
        if (materialCondition) {
          setSelectedPackages(selectedPackages.filter((m) => m != itemMaterial));
          setSelectedPackages([])
        } else {
          setSelectedPackages([itemMaterial]);
        }
      }
    }
  }, [scanCode, selectedPackages]); 

  const showValidationErrors = (status) => {
    if (status === 1) {
      if (!selectedWasher || selectedWasher === "") {
        toast.error(t("YouMustSelectWasher") || "You must select a Washer");
      }

      if (!cycleNumber || cycleNumber === "") {
        toast.error(
          t("YouMustSelectCycleNumber") || "You must select a Cycle Washer"
        );
      }

      if (!selectedPackages || selectedPackages.length === 0) {
        toast.error(t("YouMustSelectMaterial") || "You must select a Material");
      }
    } else {
      if (!selectedWasher || selectedWasher === "") {
        toast.error(t("YouMustSelectWasher") || "You must select a Washer");
      }

      if (!cycleNumber || cycleNumber === "") {
        toast.error(
          t("BlankEntry47") || "You must select a Cycle Washer"
        );
      }

      if (!selectedPackages || selectedPackages.length === 0) {
        toast.error(t("BlankEntry48") || "You must select a Material");
      }

      if (!indicators || indicators.length === 0) {
        toast.error(
          t("YouMustSelectIndicators") || "You must select a Indicators"
        );
      }
    }
  };

  const handleButtonClick = async (status) => {
    const notValid = validateFields(status);

    if (notValid) {
      setValidate(notValid);
      showValidationErrors(status);
    } else await createCharge(status);
  };

  const isSaveDisabled = useMemo(
    () => validateFields(1),
    [selectedWasher, cycleNumber, selectedPackages]
  );
  const isFinishDisabled = useMemo(
    () => validateFields(2),
    [selectedWasher, cycleNumber, indicators, selectedPackages]
  );

  return (
    <PageContainer
      category={"Hygiene Monitoring"}
      title={vinculation ? "Linking Indicators" : "Create"}
      backUrl={"/appmanagehygienemonitoring"}
      scan={true}
      progress={false}
    >
      {vinculation ? (
        <VinculationPro
          selectedIndicator={selectedIndicator}
          reloadDetail={reload}
          handleReload={setReload}
          handleSelectedIndicator={handleSelectedIndicator}
          chargeId={chargeId}
          idManage={false}
        />
      ) : (
        <div>
          <BarcodeReader onScan={onHandleScan} />
          <ModalLoading open={modalEditLoading} />
          <ModalLoading open={modalLoading} />

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              margin: "0 auto",
              height: "100%",
            }}
          >
            <div
              style={{
                width: "68%",
                display: "flex",
                flexDirection: "column",
                gap: "2.5rem",
                height: "100%",
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "15px",
                }}
              >
                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                  <SelectQ
                    selectValue={selectedWasher}
                    handleSelect={handleChangeWasher}
                    options={Washers}
                    label={t("SelectWasherSpan") || "Select a Washer"}
                    placeholder={t("SelectWasherSpan") || "Select a Washer"}
                    containerWidth={"50%"}
                    labelTop={true}
                    required={true}
                    errorMessage={t("RequiredFieldError") || "This field is required"}
                    validate={validate}
                    category={"hygieneMonitoring"}
                    style={{ flex: 1 }}
                  />
                  <InputSearch
                    label={t("CycleNumberSpan") || "Cycle Number"}
                    name="cycleNumber"
                    handleInputChange={handleCycleNumber}
                    value={cycleNumber}
                    required={true}
                    errorMessage={t("RequiredField", locale) || "This field is required"}
                    validate={validate}
                    options={cyclesOptions}
                    handleClick={handleClick}
                    disabled={!selectedWasher}
                    onHandleScan={onHandleScan}
                    containerWidth={"50%"}
                    mandatory={true}
                    style={{ flex: 1 }}
                  />

                  {/* Checkbox */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      minWidth: "20%", 
                      justifyContent: "flex-end",
                    }}
                  >
                    <label className={styles.printLabel}>{"Ignore From IQAS"}</label>
                    <Checkbox style= {{marginTop:"15px"}} type="checkbox" checked={IQAS} onChange={handleChangeIQAS} />
                  </div>
                </div>
              </div>

              <SelectorMaterialHygiene
                filter1={
                  <SearchMaterial
                    data={packages}
                    handleFilter={handleFilteredPackages}
                    placeholder={t("BlankEntry36")}
                    searchActive={() => {}}
                    scanCode={scanCode}
                    handleClear={handleClearSearch}
                    clearData={clearSearch}
                    onHandleScan={onHandleScan}
                  />
                }
                data={filteredPackages}
                indicators={indicators}
                editId={editId}
                selectedData={selectedPackages}
                selectedFilteredData={
                  searchActive ? selectedFilteredPackages : selectedPackages
                }
                handleSelectedData={handleSelectedPackages}
                onMaterialDeselected={handleMaterialDeselected}
                onHandleScan={onHandleScan}
              />
            </div>
            <div style={{ width: "30%", minHeight: "100%", height: "30rem" }}>
              <CrudIndicator
                indicators={indicators}
                handleIndicators={handleIndicators}
                onHandleScan={onHandleScan}
                category={"hygieneMonitoring"}
                isEndoscope={isEndoscope}
                condition={t("BlankEntry77") || "a washer, cycle number and material"}
                select={selectedWasher}
                methodId={0}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              marginTop: "1rem",
              alignItems: "flex-start",
              justifyContent: "space-between",
            }}
          >
            <TextAreaQ
              label={t("ObservationSpan")}
              handleChange={handleChangeObservations}
              value={observations}
              width={"68%"}
              inputRef={observationsRef}
              category={"hygieneMonitoring"}
            />

            <div className={styles.containerButtons}>
              <button
                className={`${styles.button} ${styles.cancel}`}
                onClick={() => clearFields()}
              >
                {t("ClearFields", locale) || "Clear Fields"}
              </button>
              <button
            className={`${styles.button} ${styles.save} ${
              isSaveDisabled || stopButtons ? styles.disabled : ""
            }`}
            onClick={() => handleButtonClick(1)}
          >
            {t("Save", locale) || "Save"}
          </button>
              <button
                className={`${styles.button} ${styles.finish} ${
                  isFinishDisabled || stopButtons ? styles.disabled : ""
                }`}
                onClick={() => handleButtonClick(2)}
              >
                {t("FinishSpan", locale) || "Finish"}
              </button>
            </div>
          </div>
        </div>
      )}
    </PageContainer>
  );
}
